<template>

<div class="faqContainer">
    <div class="toppurple faqmobile" ></div>
    <div class="backgroundcontainer">
    <div class="container">
        <div class="FAQcategoryParent farsi" v-for="obj in getFaq()" :key="obj.id"  @click="toggle(obj)">
            <div class="downSVG">
                <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.939453 3.06077L3.06077 0.939453L8.00011 5.87879L12.9395 0.939453L15.0608 3.06077L8.00011 10.1214L0.939453 3.06077Z" fill="#55C38C"/>
                </svg>
            </div>
            <div class="FAQcategory">{{obj.name}}</div>
            <transition name='app-fade'>
            <div class="QuestionsContainer" v-if="obj.show">
                <div title='سوالات متداول ۷۰۳۰' class="Questions farsi" v-for="question in obj.questionArray" @click="[openModal('faq'),$store.state.question=question]" :key="question.id" v-html="question.question"></div>
            </div>
            </transition>
        </div>
    </div>
</div>

</div>

</template>

<script>


import {mapActions} from 'vuex';
export default {
    data(){
        return{
            searchResult:[
                {
                    show:false,
                    id:1,
                    name:'تیم فنی',
                    questionArray:[
                        {
                            id:1,
                            question:`برنامه نویس Back-end`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (6).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:2,
                            question:`برنامه نویس Front-end`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (5).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:3,
                            question:`برنامه نویس ios`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (2).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:4,
                            question:`برنامه نویس Android`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (4).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:5,
                            question:`متخصص امنیت`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (15).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        }
                    ]
                },
                {
                    show:false,
                    id:2,
                    name:'تیم مارکتینگ',
                    questionArray:[
                        {
                            id:6,
                            question:`مدیر فروش و بازاریابی`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (16).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        }
                    ]
                },
                {
                    show:false,
                    id:3,
                    name:'تیم طراحی',
                    questionArray:[
                        {
                            id:7,
                            question:`دیزاینر`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (14).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:8,
                            question:`طراح UI/UX`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (13).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:9,
                            question:`موشن دیزانیر`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (17).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                        {
                            id:10,
                            question:`کپی رایتر`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (18).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        }
                    ]
                },
                {
                    show:false,
                    id:4,
                    name:'تیم پشتیبانی',
                    questionArray:[
                        {
                            id:11,
                            question:`پشتیبان آنلاین`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (3).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        }
                    ]
                },
                {
                    show:false,
                    id:5,
                    name:'تیم اداری - مالی',
                    questionArray:[
                        {
                            id:12,
                            question:`مدیر دفتر`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (19).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        }, 
                        {
                            id:13,
                            question:`کارشناس مالی`,
                            answer:`
                            <img src="/images/reqruitment/Recruitment (1).jpg">
                            تیم 7030 در سال 96 با 3 نفر شروع شد و اکنون 13 نفر در کنار هم مشغول به کار هستیم. همواره هدف و برنامه‌ی مشخصی برای بهتر شدن داشته‌ایم، با وجود همه‌ی مشکلات به پیش رفته و در صورت نیاز مسیرمان را اصلاح می‌کنیم. باور داریم همه اعضاء تیم در موفقیت تاثیرگذارند، در جذب هم تیمی جدید اعتقادی به سعی و خطا نداریم، هرکدام در زمان درستی به تیم اضافه شده‌اند. بعضی از کارها روی زمین مانده که هنوز عضو مشخصی برای انجام دادن آن‌ها نداریم یا فعلاً خودمان انجام می دهیم یا برون سپاری می کنیم.  شما اگر مایلید ‌دانش و تجربه‌تان را با ما شریک شوید و هدف‌تان نیز تا حدودی با ما یکی است، رزومه‌تان را ارسال کنید. حتی می‌توانید یک فایل صوتی در کنار رزومه برای ما بفرستید داخل فایل صوتی بعد از معرفی بگویید در صورتی که در کنار ما باشید چه کارهایی می‌توانید انجام دهید.
                            `
                        },
                    ]
                }
            ],
            query:''
        }
    },
    components: {

    },
    methods: {
        getFaq(){
            return this.searchResult
        },
        toggle(obj){
            for(let i = 0; i < this.searchResult.length; i++){
                if(this.searchResult[i].id!=obj.id){
                this.searchResult[i].show = false
                }
            }
            obj.show=!obj.show

        },
        ...mapActions([
            'login',
            'openModal',
            'closeModal',
            'reOpenModal'
        ]),
    },
    watch:{
        query:function(){
            const faq=[
                {
                    show:false,
                    id:1,
                    name:'ثبت نام و عضویت',
                    questionArray:[
                        {
                            id:1,
                            question:`چگونه ثبت نام کنم؟ مراحل ثبت نام را توضیح دهید؛`,
                            answer:`1- از قسمت  ثبت نام  شماره موبایل خود را وارد کنید.
                                    2- رمز عبور دلخواه خودتوان را وارد کرده و به خاطر بسپارید.
                                    3-شناسه معرف فردی که شما را با سامانه آشنا کرده را وارد بفرمایید؛
                                    4- پس از دریافت کد فعالسازی ، آن را وارد کنید؛
                                    در ادامه، ضمن اینکه می ­توانید خریدهایتان را انجام دهید قادر خواهید بود آن را به دوستان، مخاطبین یا فالوورهایتان معرفی کنید.`
                        },
                        {
                            id:2,
                            question:`کد فعالسازی (کد تایید) ارسال نمی شود؟`,
                            answer:`گاهی اوقات ممکن است کد تایید با تاخیر به دست شما برسد؛
                                    اگر کد فعالسازی را دریافت نکردید،  یا دریافت کردید و اشتباه بود، راه حل جایگزین وجود دارد؛
                                    راه حل جایگزین این است که :
                                    عدد 7030 را به شماره 10000070307030 پیامک کنید؛
                                    پس از اطمینان از ارسال شدن پیامک، فعالسازی حساب کاربری شما انجام شده است؛
                                    و فقط کافی است که از قسمت ورود، وارد سامانه شوید؛`
                        },
                        {
                            id:3,
                            question:`رمز ورود خود را فراموش کرده ام، چگونه آن را بازیابی کنم؟`,
                            answer:`در قسمت "ورود" از گزینه ی " کلمه عبور را فراموش کرده ام" استفاده بفرمایید؛`
                        },
                        {
                            id:4,
                            question:`آیا پس از ثبت نام میتوانم کد معرفی که با آن دعوت شده ام را عوض کنم؟`,
                            answer:`خیر؛ این امکان به هیچ وجه وجود ندارد؛ به جهت ارج نهادن به زحمات کسی که شما را با سامانه آشنا کرده امکان تغییر کد معرف پس از ثبت نام وجود ندارد. ولی می‌توانید با یک شماره تلفن دیگر مجدداً ثبت نام کنید؛`
                        },
                        {
                            id:5,
                            question:`چگونه میتوان با دو سیم کارت ثبت نام کرد؟`,
                            answer:`پس از ثبت نام با سیم کارت اول، می توانید از بخش تنظیمات گزینه خروج از حساب کاربری را بزنید؛
                            سپس با سیم کارت جدید ثبت نام بفرمایید؛`
                        },
                        {
                            id:6,
                            question:`آیا می‌توان با چند نام و شناسه فعالیت کرد؟`,
                            answer:`بله، با هر شماره تلفن می توان یک حساب کاربری داشت و با هر حساب کاربری نیز می­ توانید تا سقف 5 شناسه (یا کد معرف) که معرف اسم، اسم کانال یا پیج، نام کسب وکار یا برند شماست، ثبت نمایید و با آنها به جذب مدعو و فعالیت بپردازید.`
                        },
                        {
                            id:7,
                            question:`خودم با 7030 آشنا شده ام و کسی من را معرفی نکرده، چگونه بدون معرف ثبت نام کنم؟`,
                            answer:`با توجه به اینکه وارد کردن کدمعرف جهت ثبت نام الزامی است،  باید کد معرف شخصی که شما را با سامانه آشنا کرده و را وارد بفرمایید؛
                            اگر کسی شما را معرفی نکرده است، می توانید از لینک زیر اقدام به ثبت نام بفرمایید؛
                            https://7030.ir/r/direct
                            شناسه‌ی معرف هنگام ثبت نام: direct
                            لازم به ذکر است که تمامی کدهای معرف یکسان هستند و هیچ تفاوتی با هم ندارند و نحوه سود دهی کاملا یکسان است؛`
                        },
                    ]
                },
                {
                    show:false,
                    id:2,
                    name:' دعوت دوستان و عضوگیری',
                    questionArray:[
                        {
                            id:8,
                            question:`آیا محدودیت دعوت وجود دارد؟ (به صورت مستقیم تا چند نفرمیتوانیم دعوت کنیم؟)`,
                            answer:`هیچ محدودیتی در تعداد دعوت مستقیم وجود ندارد و شما میتوانید بینهایت به طور مستقیم با کد معرف خود دعوت بفرمایید؛`
                        },
                        {
                            id:9,
                            question:`معرفی دوستان و ایجاد شناسه دعوت (کد معرف) چگونه است؟`,
                            answer:`پس از ثبت نام ، به صورت پیش فرض، شماره موبایلی که با آن ثبت نام نموده اید، شناسه دعوت (کد معرف) شماست؛
                            همچنین برای تغییر شناسه دعوت خود میتوانید در اپلیکیشن از قسمت مدعوین گزینه افزودن شناسه جدید را انتخاب بفرمایید؛
                            اگر از سایت استفاده میکنید، در پنل کاربری ، از گزینه اطلاعات کاربر و شناسه ها / افزودن شناسه را انتخاب کنید
                            و شناسه هایی با نام های دلخواه بسازید و سپس از گزینه کپی دعوتنامه استفاده بفرمایید و آنها را در شبکه های اجتماعی ارسال نمایید؛`
                        },
                        {
                            id:10,
                            question:`چگونه دیگران را دعوت کنم تا برای من سود داشته باشد؟`,
                            answer:`پس از ثبت نام به صورت پیش فرض، شماره موبایلی که با آن ثبت نام نموده اید، شناسه ی دعوت شماست،
                            همچنین می توانیداز گزینه افزودن شناسه جدید که در قسمت مدعوین قرار دارد استفاده کرده و شناسه هایی با نام های دلخواه بسازید و سپس گزینه کپی دعوتنامه را زده  و آنها را در شبکه های مجازی تبلیغ کنید. با ثبت نام آنها با کد معرف شما، از هر تراکنش آنها سود خواهید برد؛`
                        },
                        {
                            id:11,
                            question:`یک نفر را معرفی کردم، ولی برای من نمایش داده نمی شود؛`,
                            answer:`چنین موردی اساسا امکان پذیر نیست،
                            لطفا ابتدا، هم خود و هم فرد معرفی شده، نرم افزارتان را بروزرسانی بفرمایید، و سپس به معرفی شده بفرمایید که در حساب کاربری خود، در قسمت تنظیمات ببینند که آیا  که کد معرف شما ثبت شده است یا خیر؛
                            و همچنین خود شما نیز لطف بفرمایید از بخش مدعوین همین شناسه تان ، به دنبال شماره موبایل ایشان بگردید و برای ما از طریق پشتیبانی اسکرین شات ارسال بفرمایید تا به تیم فنی ارجاع گردد؛`
                        },
                        {
                            id:12,
                            question:`افرادی که معرفی کردم و درآمد حاصل از آن ها را از کجا میتوانم ببینم؟`,
                            answer:`در اپلیکیشن، در قسمت مدعوین ، تمامی افرادی که با هر کدام از شناسه های شما ثبت نام کرده باشند، با کلیک روی آن شناسه نمایش داده خواهند شد؛ همچنین میزان درآمد شما از هرکدام از آن ها نیز در مقابل آنها نوشته شده است؛`
                        },
                        {
                            id:13,
                            question:`شرایط حذف یکی از شناسه های معرف چگونه است و در صورت حذف ، مدعوین آن چه می شوند؟`,
                            answer:`امکان حذف شناسه در اپلیکیشن 7030 در قسمت مدیریت شناسه ها فراهم شده است ولی در صورتی که بعد از حذف آن، شناسه مورد نظر از سوی شخص دیگری رزرو شود، امکان بازپس ­گیری و فعالیت با آن وجود ندارد. (در صورت حذف یکی از شناسه هایتان، کسانی که با آن شناسه وارد سامانه شده باشند به شناسه پیش فرض، یعنی شناسه شماره تلفنتان منتقل می ­شوند و تعدادشان در قسمت "شناسه­ های حذف شده" قابل رویت است.)`
                        },
                        {
                            id:14,
                            question:`چرا هر شناسه ای میخواهم بسازم قبول نمی کند؟ (ساخت شناسه معرف جدید برای خود، چه الزاماتی دارد؟)`,
                            answer:`شناسه حتما باید شرایط زیر را داشته باشد:
                            1-باید از کاراکتر های انگلیسی و اعداد استفاده شود،
                            2-توسط شخص دیگری انتخاب نشده باشد
                            3- باید 5 کاراکتر یا بیشتر باشد
                            4- بین حروف فقط از _ میتوان استفاده کرد؛`
                        },
                        {
                            id:15,
                            question:`جهت تبلیغات و آموزش به افراد دعوت شده آیا مطالب و تصاویر گرافیکی آماده دارید؟`,
                            answer:`بله؛ برای این کار می توانید از مطالب سایت و کانال تلگرام ما با عنوان #متریال استفاده بفرمایید؛
                            @ir_7030
                            https://t.me/ir_7030`
                        },
                        {
                            id:16,
                            question:`چرا در اینستاگرام نمیتوان لینک 7030 را به اشتراک گذاشت؟`,
                            answer:`بدليل لطف فراوان و استفاده روزافزون كاربران و دعوت كنندگان از لينك سايت 7030 اينستاگرام متاسفانه اين لينك را به عنوان لينك اسپم شناسايي كرده و از اشتراك آن جلوگيري مي كند. بديهي است تيم هفتادسي در حال مذاكره با اينستاگرام براي حل اين موضوع است.
                            فعلا از كاربران عزيز تقاضا مي كنيم براي اشتراك كد معرف خود به جاي قرار دادن آدرس كامل لینک، تنها از خود شناسه به عنوان شناسه معرف در متن استفاده نمايند.
                            https://www.instagram.com/p/BnVl6F9laU_/?utm_source=ig_web_copy_link`
                        },
                    ]
                },
                {
                    show:false,
                    id:3,
                    name:'درآمدزایی از 7030',
                    questionArray:[
                        {
                            id:17,
                            question:`چگونه درآمدزایی کنم؟`,
                            answer:`شما ضمن اینکه خریدهای خود را از طریق سیستم بهینه ­ی ۷۰۳۰ انجام می ­دهید، با ارسال لینک دعوت خود (که حاوی کد معرف شماست) به دوستانتان از طرق مختلف، و ثبت نام آنها در سامانه، به شبکه مخاطبین ۷۰۳۰ می ­پیوندند و شما نیز از این موضوع مطلع خواهید شد. داشتن مدعو بیشتر به معنای کسب درآمد بیشتر است.`
                        },
                        {
                            id:18,
                            question:`درآمد من چگونه به من پرداخت می ­شود؟`,
                            answer:`سود تراکنش ها مستقیما به عنوان مبلغ به تومان به اعتبار شما در سامانه اضافه می شود و هت برداشت آن ، هر زمان که تمایل داشتید، از بخش شماره حساب ها شماره شبا ی خود را وارد کرده و گزینه درخواست واریز را می زنید؛
                            1-مبلغ نهایتا  تا 7 روز کاری (7 روز غیر تعطیل) به حساب شما واریز می گردد.
                            2- حداقل مبلغ قابل واریز 5000 تومان است.`
                        },
                        {
                            id:19,
                            question:`شماره شبا چیست؟ چرا لازم است؟ و چگونه میتوان آن را دریافت کرد؟`,
                            answer:`شماره شبا را به سه طریق می ­توان به دست آورد؛ 
                            1- مراجعه حضوری به بانک مربوطه؛
                            2- مراجعه به عابر بانک مربوطه؛
                            3- گرفتن آن از طریق وبسایت بانک ­های مربوطه؛
                            بنا به درخواست کاربران عزیز در یک پست در وبلاگ هفتادسی در لینک زیر توضیحات کامل در مورد شماره شبا ارائه گردیده است؛ 👇👇👇
                            www.yon.ir/sheba7030`
                        },
                        {
                            id:20,
                            question:`با توجه به سود کم محصولی مانند شارژ، آیا ارزش دارد وقت خود را صرف این کار کنیم؟`,
                            answer:`بله، در بازار فعلی، فروش شارژ سیمکارت ­های اعتباری سودی حدوداً معادل ۶۰ میلیارد تومان در ماه و در سال حدود ۷۲۰ میلیارد تومان می‌باشد. در صورتی که ما بتوانیم حتی یک درصد از بازار شارژ را پوشش دهیم، در سال مبلغ ۷.۲ میلیارد تومان سود داشته که ۷۰% از این مبلغ یعنی، ۵ میلیارد تومان به کاربران تعلق می‌گیرد. ضمن اینکه پرداخت‌های قبض و بسته‌های اینترنتی نیز هر کدام تقریبا همین‌ مقدار سود دارد.`
                        },
                        {
                            id:21,
                            question:`طرح درآمدی (پلن درآمدی) به چه صورت است؟`,
                            answer:`طرح درآمدی در حال اجرا  به صورت تک سطحی و به این صورت است که بطور میانگین سود هر تراکنش 3درصد می باشد که 40 درصد از سود هر تراکنش به معرف مستقیم تقدیم می گردد و 30 درصد به خود خریدار، الباقی سود (30درصد) به 7030 تعلق میگیرد؛ لطفا به تبلیغاتی که توسط برخی کاربران در مورد طرح 7سطحی قبلی می باشد، توجه نفرمایید.`
                        },
                        {
                            id:22,
                            question:`تفاوت مدعوین با کل مدعوین چیست؟`,
                            answer:`مدعوین افرادی هستند که به طور مستقیم معرفی کردید و هنگام ثبت نام کد معرف شما را وارد کرده اند،
                            کل مدعوین، غیر مستقیم ها را هم شامل می شود؛
                            در حال حاضر فقط از مدعوین مستقیم سود دریافت می نمایید، ولی در آینده از مدعوین غیر مستقیم شما نیز سود پرداخت خواهد شد`
                        },
                        {
                            id:23,
                            question:`چه تضمینی وجود دارد که تا آخر 70 درصد از سود خود را به کاربران پرداخت کنید؟`,
                            answer:`اساساً هدف اصلی از شکل گیری 7030 این است که به جای هزینه های گزاف تبلیغات تلویزیونی و ...، این مبالغ را به عنوان سود تراکنش ها و همچنین پاداش فعالیت، به کاربران فعال پرداخت کند؛
                            همانطور که از اسم 7030 پیداست 70 درصد از سود به کاربران پرداخت خواهد شد؛
                            قطعا بزرگترین سرمایه 7030 کاربران فعال هستند و باید رضایت آنها را جلب کند؛ چه تضمینی از این بالاتر می تواند وجود داشته باشد؟`
                        },
                        {
                            id:24,
                            question:`میزان دقیق سود هر خرید چقدر است؟`,
                            answer:`مقدار سود هر محصول بستگی به قیمت آن و شرکتی که آن را برای ما تامین می ­کند و با او قرارداد منعقد کرده­ ایم، دارد.
                            ✅ تمام سود فروش هر شارژ به طور میانگین، ۳ درصد مبلغ آن است 
                            - یعنی تمام سود یک شارژ ۱۰ هزار تومانی، ۳۰۰ تومان
                            - تمام سود یک شارژ ۵ هزار تومانی، ۱۵۰ تومان
                            - تمام سود یک شارژ ۲ هزار تومانی، ۶۰ تومان
                            - تمام سود یک شارژ هزار تومانی، ۳۰ تومان است و بسته های اینترنت هم به همین صورت.

                            ✅ تمام سود فروش هر بسته ی اینترنتی ۳ درصد مبلغ آن است یعنی مثلا یک بسته ی اینترنتی ۸ هزارتومانی، ۲۴۰ تومان است.

                            ✅ برای پرداخت قبض نیز فعلا مبلغ 100 تومان برای هر قبض پرداخت می شود (بدون در نظر گرفتن مبلغ قبض)

                            70% که میشود 70 تومان به معرف مستقیم
                            و
                            30% که میشود 30 تومان، به پرداخت کننده پرداخت میشود

                            ✅ با توجه به اینکه خدمات انتقال وجه به تازگی راه اندازی شده است، و مستقیما توسط درگاه بانکی انجام می شود و از طرف درگاه بانکی، به سامانه 7030 سودی پرداخت نمی شود،  در حال حاضر برای سامانه 7030 سودی در بر ندارد که آن را به کاربران پرداخت کند؛
                            ✅ پرداخت قبض سیم کارت دائمی ایرانسل با استفاده از خرید شارژ مستقیم نیز، در حال حاضر سودی ندارد؛
                            به زودی با بالا رفتن حجم تراکنش ها، میتوان با درگاه بانکی جهت دریافت سود، مذاکره کرد؛ 
                            در این خصوص در صفحات رسمی 7030 اطلاع رسانی انجام خواهد شد
                            **************************
                            مرحله به مرحله ، خدمات سایت کامل خواهد شد ؛ خدماتی مثل بلیط های فرهنگی (تئاتر، سینما و کنسرت)، بلیط های مسافرتی (هواپیما، اتوبوس، هتل)، انواع بیمه و سایر محصولات اعتباری مانند کدهای فعال‌ سازی انواع نرم افزارها و نیز گیفت کارت‌ها و... که سودآوری بیشتری دارند؛`
                        },
                        
                    ]
                },
                {
                    show:false,
                    id:4,
                    name:'برداشت وجه و افزایش اعتبار',
                    questionArray:[
                        {
                            id:25,
                            question:`برای برداشت مبلغی که خودم افزایش اعتبار داده ام چه کاری باید انجام بدهم؟`,
                            answer:`با توجه به دستوری که از مراجع قانونی به ما ابلاغ شده ، بازگشت مبالغی که به صورت افزایش اعتبار بوده، فقط به همان کارتی که با آن پرداخت انجام شده میسر است، و همچنین باید اطلاعات هویتی صاحب کارت به شرح زیر دریافت گردد:
                            1- تصویر کارت ملی صاحب کارت؛
                            2- تصویر کارت بانکی که با آن پرداخت انجام شده (جهت حفظ امنیت بیشتر، تاریخ انقضا و کد cvv2 پوشانده شود)؛
                            3- یک برگه که روی آن شماره موبایلی که با آن حساب کاربری دارید و تاریخ روز و نام و نام خانوادگی نوشته شده باشد؛
                            📌لازم به ذکر است که حتما هر 3 مورد فوق باید در یک عکس قرار گرفته باشد؛`
                        },
                        {
                            id:26,
                            question:`درخواست واریز زدم؛ مبلغ را از اعتبار من کم کرد ولی به حساب بانکی من واریز نشد؛`,
                            answer:`زمانی که درخواست واریز می زنید، مبلغ از اعتبار شما خارج شده و در صف واریز قرار میگیرد، (به اصطلاح hold می شود) تا از طریق امور مالی، به حساب شما حواله ی پایا شود؛
                            این فرآیند از یک روز تا 7 روز ممکن است زمان بر باشد؛`
                        },
                    ]
                },
                {
                    show:false,
                    id:5,
                    name:'خرید شارژ و بسته اینترنت',
                    questionArray:[
                        {
                            id:27,
                            question:`کد شارژ خریدم، کجا میتونم ببینم و استفاده کنم؟`,
                            answer:`کد شارژ هایی که خریداری می نمایید، در بخش تراکنش ها قرار می گیرند،
                            در بخش تراکنش ها روی تراکنش مربوطه کلیک کنید ، کد شارژ شما قابل مشاهده و قابل استفاده است؛`
                        },
                        {
                            id:28,
                            question:`آیا قیمت های محصولات شما از جاهای دیگر بیشتر است؟`,
                            answer:`خیر، به هیچ وجه؛ قیمت محصولات اعتباری و اپراتوری توسط اپراتور تعیین شده و ما هیچ گونه دخل و تصرفی در آن نداریم و قیمت در همه جا یکسان است؛
                            هر خرید شامل مالیات بر ارزش افزوده است، در فروشگاه های دیگر معمولا ابتدا قیمت خام را نمایش می دهند، سپس هنگام کسر وجه، مبلغ با مالیات را از شما کسر می کنند،
                            در 7030 جهت شفاف بودن و صداقت بیشتر، در همان ابتدا قیمت اصلی و قیمت نهایی نمایش داده شده است؛`
                        },
                        {
                            id:29,
                            question:`جهت خرید بیش از سقف تعیین شده در روز چه کاری باید انجام داد؟`,
                            answer:`خرید هر چه بیشتر کاربران باعث خرسندی ماست؛
                            ولی جهت حفظ امنیت کاربران و طبق قوانین تجارت الکترونیک، جهت افزایش اعتبار و یا خرید بیش از سقف تعیین شده، نیاز به احراز هویت حساب کاربری و کارتی که با آن قصد پرداخت دارید است، و باید اطلاعات هویتی صاحب حساب کاربری به شرح زیر دریافت گردد:

                            1- تصویر کارت ملی صاحب کارت؛
                            2- تصویر کارت بانکی که با آن پرداخت ها انجام خواهد شد (جهت حفظ امنیت بیشتر، تاریخ انقضا و کد cvv2 پوشانده شود)؛
                            3- یک برگه که روی آن شماره موبایلی که با آن حساب کاربری دارید و تاریخ روز نوشته شده باشد؛

                            📌لازم به ذکر است که هر 3 مورد فوق باید در یک عکس قرار گرفته باشد؛`
                        },
                        {
                            id:30,
                            question:`آیا شارژ یا بسته اینترنت خریداری شده ، پس از فعال شدن امکان بازگشت دارد؟`,
                            answer:`خیر؛ شارژ و بسته اینترنت مستقیما از سمت اپراتور انجام می شود و به هیچ وجه از سمت ما قابلیت بازگشت ندارد؛`
                        },
                    ]
                },
                {
                    id:6,
                    name:' پرداخت قبض',
                    questionArray:[
                        {
                            id:31,
                            question:`پرداخت قبض انجام دادم، نوشته ناموفق، ولی پول از حسابم کسر شده، چیکار کنم؟`,
                            answer:`گاهی اوقات پرداخت قبوض به اشتباه پرداخت نشده نمایش داده میشود. درصورتیکه پرداخت موفق بوده، (که دلیل این امر، عدم پاسخدهی لحظه ای بانک به ما می باشد) درنتیجه همکاران به طور دوره ای پرداخت قبض هایی که ناموفق قید شده اند را مجدد بررسی کرده و مشکلش را برطرف می کنند، در این خصوص جای هیچ نگرانی نیست و سود تمام تراکنش های شما اصلاح خواهد شد.
                            لطفا کد پیگیری (شماره مرجع) 12 رقمی  تراکنش، یا  شماره کارتی که با آن پرداخت نموده اید را از طریق پشتیبانی برای ما ارسال بفرمایید تا از درگاه بانکی پیگیری های لازم صورت گیرد؛`
                        },
                        {
                            id:32,
                            question:`قبض موبایلم را چگونه پرداخت کنم؟`,
                            answer:`در حال حاضر پرداخت قبض موبایل فقط با استفاده از شناسه قبض و شناسه پرداخت امکان پذیر است، 
                            قابلیت استعلام قبض و پرداخت مستقیم نیز به زودی فعال خواهد شد؛`
                        },
                        {
                            id:33,
                            question:`آیا پرداخت قبض و یا انتقال وجه با اعتبار درون برنامه ای 7030 امکانپذیر است؟`,
                            answer:`خیر، در حال حاضر پرداخت قبض و انتقال وجه به دلیل اینکه عملیات بانکی محسوب می شوند، با استفاده از اعتبار درون برنامه ای 7030  امکان پذیر نیست و  فقط از طریق درگاه بانکی قابل انجام است؛
                            ولی در خرید های محصولات اعتباری  می توانید از اعتبار خود استفاده بفرمایید؛`
                        },
                        {
                            id:34,
                            question:`افزایش اعتبار دادم ولی نمیشه قبض پرداخت کرد، الان چه کاری بکنم؟`,
                            answer:`در حال حاضر پرداخت قبض فقط از طریق درگاه بانکی امکان پذیر است؛ و با اعتبار امکان پذیر نیست؛
                            در خرید های دیگر می توانید از اعتبار خود استفاده بفرمایید و یا درخواست واریز بزنید؛`
                        },
                        {
                            id:35,
                            question:`قبض پرداخت کردم، چقدر زمان می برد تا بدهی من در سازمان مربوطه صفر شود؟`,
                            answer:`تسویه حساب بانک با سازمانها معمولا  3 روز یک بار است ولی پس از پرداخت مبلغ توسط بانک، زمان بروزرسانی سیستم سازمان ها و صفر کردن بدهی متفاوت است، بعضی سازمان ها سریع و بعضی کند است
                            جهت اطلاع دقیق تر می توانید از طریق شماره زیر مستقیما با پشتیبانی درگاه بانکی در تماس باشید؛
                            021 - 2318`
                        },
                        {
                            id:36,
                            question:`قبض دائمی ایرانسل از طریق خرید شارژ مستقیم، سود دارد؟`,
                            answer:`خیر، در حال حاضر پرداخت قبض ایرانسل از طریق شارژ مستقیم سیم کارت دائمی سودی در بر ندارد`
                        },
                    ]
                },
                {
                    show:false,
                    id:7,
                    name:'کارت به کارت',
                    questionArray:[
                        {
                            id:37,
                            question:`تراکنش کارت به کارت انجام دادم ولی پول منتقل نشده، چطور میتونم پیگیری کنم؟`,
                            answer:`با توجه به اینکه کارت به کارت، مستقیما از درگاه پارسیان انجام می شود،
                            پیگیری تراکنش توسط پشتیبانی درگاه با شماره تماس زیر قابل انجام است؛
                            021 - 2318`
                        },
                        {
                            id:38,
                            question:`با کارت چه بانکهایی می توان کارت به کارت کرد؟`,
                            answer:`"با توجه به اینکه  انتقال وجه کارت به کارت به تازگی راه اندازی شده ، فعلا فقط از سه بانک مبدا پارسیان ، انصار، و توسعه تعاون به هر بانک مقصدی امکان انجام دارد،
                            به زودی بانکهای دیگر نیز اضافه خواهند شد؛"`
                        },
                        {
                            id:39,
                            question:`سود کارت به کارت چگونه است؟`,
                            answer:`با توجه به اینکه خدمات انتقال وجه به تازگی راه اندازی شده است، در حال حاضر برای سامانه 7030 سودی در بر ندارد و مستقیما توسط درگاه بانکی انجام می شود و از طرف درگاه بانکی، به سامانه 7030 سودی پرداخت نمی شود،
                            به زودی با بالا رفتن حجم تراکنش ها، میتوان با درگاه بانکی جهت دریافت سود، مذاکره کرد؛`
                        },
                        {
                            id:40,
                            question:`آیا از طریق سایت نیز می توان کارت به کارت کرد؟`,
                            answer:`خیر، در حال حاضر انتقال وجه کارت به کارت فقط از طریق اپلیکیشن اندروید و ios امکان پذیر است؛`
                        },
                    ]
                },
                {
                    show:false,
                    id:8,
                    name:'درگاه بانکی و پرداخت',
                    questionArray:[
                        {
                            id:41,
                            question:`پیغام (تراکنش توسط دارنده کارت مجاز نیست) برای چیست؟`,
                            answer:`بعضی بانک ها برای بعضی از درگاه ها، محدودیت حداقل مبلغ تراکنش قرار داده اند،
                            مثلا بانک ملت محدودیت حداقل مبلغ 10 هزار تومان دارد؛
                            یعنی تراکنش های کمتر از مبلغ 10 هزار تومان را نمی پذییرد؛
                            به زودی با اضافه شدن درگاه های بانکی دیگر به سامانه، این مورد نیز برطرف خواهد شد؛`
                        },
                        {
                            id:42,
                            question:`آیا تا آخر باید پرداخت را از طریق اینترنت و با شماره کارت و… انجام دهیم؟`,
                            answer:`خیر، برای پرداخت سه روش در سایت و اپلیکیشن تعبیه شده است، 
                            1- پرداخت به صورت آنلاین و در درگاه پرداخت اینترنتی؛ 
                            2- پرداخت درون برنامه ای است که با یکبار ذخیره کردن اطلاعات کارت بانکی خود، برای پرداخت های بعدی فقط با وارد کردن رمز دوم، محصول خود را خریداری می نمایید؛
                            3- روش سوم پرداخت، پرداخت از طریق اعتبار درون برنامه ای 7030  است که کاربر می تواند از طریق درآمدی که از هفتادسی کسب کرده و یا با افزایش اعتبار قبلی خود، صرفا با یک کلیک خرید خود را انجام دهد.`
                        },
                        {
                            id:43,
                            question:`7030 در تبلیغات ادعای خرید سریع و آسان می کند، روش خرید سریع چگونه است؟`,
                            answer:`سریعترین روش خرید، پرداخت از طریق اعتبار است که کاربر می تواند از طریق درآمدی که از هفتادسی کسب کرده و یا با افزایش اعتبار درون برنامه ای به میزان مورد نیاز برای خریدهای آینده ی خود، صرفا با یک کلیک خریدهای خود را انجام دهد.`
                        },
                        {
                            id:44,
                            question:`چرا بعضی پرداخت ها با مشکل مواجه می ­شوند؟`,
                            answer:`ضمن پوزش پیشاپیش در صورت وقوع خطا قبل و پس از پرداخت، با تعبیه سیستم­ های جدید و قراردادن سایت بر سرور ابری این مساله مرتفع خواهد شد. و همچنین تراکنش های ناموفق تماما پیگیری خواهد شد؛ لطفا صبور باشید و دلزده نشوید و تا آخر کنار ما بمانید تا باهم به جاهای بهتری برسیم؛`
                        },
                    ]
                },
                {
                    show:false,
                    id:9,
                    name:'امنیت و مجوزها',
                    questionArray:[
                        {
                            id:45,
                            question:`هنگام پرداخت چگونه به 7030 اعتماد کنیم و مشخصات کارت خود را وارد کنیم؟`,
                            answer:`پرداخت ها مستقیما از طریق درگاه بانکی انجام می شود؛
                            هنگام پرداخت در هر سایتی حتما دقت بفرمایید که فقط در درگاه بانکی میتوانید اطلاعات کارت خود را وارد بفرمایید؛
                            درگاه های بانکی مورد استفاده ی سایت ما درحال حاضر درگاه تجارت الکترونیک بانک پارسیان و درگاه بانک پاسارگاد هستند و به زودی درگاه های دیگر نیز افزوده خواهد شد؛`
                        },
                        {
                            id:46,
                            question:`آیا ۷۰۳۰ سیستمی امن و قابل اطمینان است؟`,
                            answer:`بله، هفتاد سی با استانداردها و تکنولوژی روز و امنیت بالا طراحی و پیاده سازی شده است و در پرداخت‌های خود نیز از درگاه­ های امن بانکی استفاده می­ کند. هفتاد سی صرفاً یک واسطه و رابط بین فروشنده و خریدار می ­باشد و اطلاعات بانکی حساب شما به هیچ وجه در سرورهای هفتاد سی ذخیره نمی ­شود، بلکه تماماً مربوط به خود درگاه­ های بانکی است؛`
                        },
                        {
                            id:47,
                            question:`مجوز های 7030 را از کجا میتوان مشاهده کرد؟`,
                            answer:`در  لینک زیر مجوز های سایت را می توانید مشاهده کنید؛
                            https://7030.ir/enemad
                            همچنین می توانید به سایت enamad.ir بروید در قسمت استعلام ، با وارد کردن آدرس:
                            7030.ir
                            نتیجه را مشاهده بفرمایید؛`
                        },
                        {
                            id:48,
                            question:`آیا ۷۰۳۰ قانونی است؟`,
                            answer:`بله، اختصاص سود به بازاریابان در همه‌ی کسب و کارها مرسوم بوده و در حال انجام می‌باشد. سایت ۷۰۳۰ مجوزهای نظارت بر کسب و کارهای دیجیتال وزارت صنعت، معدن و تجارت (Enamad)، مجوز مرکز ساماندهی رسانه‌های دیجیتال وزارت ارشاد و مجوز انجمن صنفی کسب و کار اینترنتی را دریافت کرده است.`
                        },
                    ]
                },
                {
                    show:false,
                    id:10,
                    name:'دانلود اپلیکیشن، آپدیت ها و بر نامه های آینده',
                    questionArray:[
                        {
                            id:49,
                            question:` چطور می توانم اپلیکیشن را دانلود (بروزرسانی) کنم؟`,
                            answer:`ازاین لینک میتوانید ورژن متناسب با گوشیتان را از مارکت های معتبر دانلود یا بروزرسانی بفرمایید؛
                            https://7030.ir/download`
                        },
                        {
                            id:50,
                            question:`فقط شارژ و قبض در سایت ارائه می‌شود؟`,
                            answer:`خیر، شارژ و بسته ­های اینترنت و قبص از اولین محصولات سایت هفتاد سی هستند که برنامه ­ای مدون و حساب شده برای افزودن محصولات متنوع و کاربردی وجود دارد که در موقع خود، پیاده سازی، منتشر و اطلاع رسانی خواهد شد.`
                        },
                        {
                            id:51,
                            question:`روش دانلود اپلیکیشن در گوشی های آیفون چگونه است؟`,
                            answer:`نسخه آیفون (ios)را می توانید در سیب اپ از لینک زیر دانلود بفرمایید؛
                            https://new.sibapp.com/applications/7030
                            همچنین لینک مستقیم ios نیز در زیر قرار داده شده است:
                            https://7030.ir/dl/ios/latest
                            همچنین آموزش اعتماد سازی اپلیکیشن برای آیفون نیز در لینک زیر قرار دارد:
                            7030.ir/tutorials/ios`
                        },
                        {
                            id:52,
                            question:`پرداخت از طریق کد دستوری (USSD) یا (#7030*) ندارید؟ چرا آن را راه اندازی نمی ­کنید؟`,
                            answer:`خیر؛ 7030 فقط در بستر سایت، اپلیکیشن اندروید و اپلیکیشن ios فعالیت دارد؛
                            و کد دستوری (ussd) ندارد (*7030# مربوط به سامانه 7030 نیست)
                            بنا بر نظر قاطع کارشناسان و فعالان حوزه پرداخت USSD یک سامانه منسوخ قدیمی و نا امن است که به طرز استثنایی و عجیبی در ایران به خاطر انحصارهایی که وجود دارد به این میزان استفاده می‌شود. خبرهای رسمی مبنی بر محدودیت ­ها و ممنوعیت ­های آن در آینده به گوش می ­رسد. سامانه هفتاد سی در آینده با همکاری با PSP های معتبر از آخرین روش های پرداخت موبایلی استفاده خواهد کرد.`
                        }
                    ]
                },
                {
                    show:false,
                    id:11,
                    name:'سوالات عمومی',
                    questionArray:[
                        {
                            id:54,
                            question:`7030 چیست؟`,
                            answer:`«هفتاد سی» یک سامانه اینترنتی (وبسایت:www.7030.ir) و اپلیکیشن (اندروید و IOS ) پرداخت و خرید محصولات اعتباری (غیر فیزیکی) شامل خدمات اپراتوری(خرید شارژ و بسته­­ های اینترنت، پرداخت قبوض)، بلیط­ های فرهنگی (تئاتر، سینما و کنسرت)، بلیط­ های مسافرتی (هواپیما، اتوبوس، هتل)، انواع بیمه و سایر محصولات اعتباری مانند کدهای فعال‌ سازی انواع نرم افزارها و نیز گیفت کارت‌ها می‌­باشد که توسط شرکت «خلاق افق رویداد» طراحی، تولید و راه اندازی شده است.`
                        },
                        {
                            id:55,
                            question:`۷۰۳۰ دقیقاً چگونه کار می کند؟`,
                            answer:`۷۰۳۰ خدمات خود را در قالب وب سایت و اپلیکیشن ارائه می‌دهد و مدل تبلیغات و بازاریابی آن برپایه‌ی شبکه‌های اجتماعی و مکانیزم‌های طبیعی بازار است، به این صورت که هزینه تبلیغات به جای استفاده در روش‌های متداول و سنتی مانند تلویزیون، بنر، بیلبورد و … از طریق دعوت مشتریان جدید توسط مشتریان فعلی و تخصیص سود به معرفان و تبلیغ کنندگان انجام می ­پذیرد. هفتاد سی، ۷۰% از سود خود را به کاربران، فعالان و معرفان اختصاص می‌دهد`
                        },
                        {
                            id:56,
                            question:`۷۰۳۰ از چه مزیت‌هایی برخوردار است؟`,
                            answer:`1-  برطرف‌ سازی عمده‌ی نیازهای روزمره و متداول کاربران در یک فضای یکپارچه، رابط کاربری مدرن و تجربه‌ی کاربری خوشایند و با استاندارد بالا  
                            2- ایجاد یک هاب و مرکز فروش برای تولیدکنندگان، توزیع کنند‌گان و فروشندگان خدمات اعتباری و کاهش هزینه­ های فروش و بازاریابی ایشان 
                            3- استفاده از روش‌های به روز، موثر و کم‌هزینه تبلیغاتی و اتخاذ استراتژی بازاریابی بر روی شبکه اجتماعی و ایجاد باشگاه مشتریان و ایجاد مشوق‌ها برای توسعه‌ی بازار توسط مشتریان.`
                        },
                        {
                            id:57,
                            question:`چرا شماره تلفن پشتیبانی ندارید؟`,
                            answer:`درصورتی که با تاخیر خدمت شما پاسخگویی انجام شده صمیمانه پوزش می طلبیم، در حال حاضر جهت پشتیبانی مرکز تماس و پشتیبانی آنلاین و 24ساعته نداریم و پشتیبانی از طریق چت در لینک زیر انجام می شود؛
                            https://7030.ir/support
                            با توجه به حجم بالای سوالات، به ترتیب پاسخ داده خواهد شد؛`
                        },
                        {
                            id:58,
                            question:`چگونه میتوان از سامانه خارج شد و حساب کاربری خود را حذف کرد؟`,
                            answer:`برای این کار می توانید، از بخش تنظیمات، گزینه خروج از حساب کاربری را انتخاب بفرمایید؛
                            چون سامانه 7030، خدمات مالی ارائه می دهد، امکان حذف کامل حساب کاربری وجود ندارد؛`
                        },
                        {
                            id:59,
                            question:`پس از نصب اپلیکیشن دلیل دسترسی هایی که خواسته شده چیست؟`,
                            answer:`دسترسی هایی که در اپلیکیشن خواسته شده، برای استفاده هایی است که در اپلیکیشن دارد،
                            مثلا دسترسی مخاطبین برای انتخاب شماره توسط کاربر از درون آن برای خرید و ارسال شارژ برای شماره مورد نظر بدون نیاز به اینکه شماره را حفظ باشد، 
                            دسترسی دوربین برای اسکن بارکد جهت پرداخت قبض و همچنین دسترسی های دیگر نیز به همین ترتیب برای کاربردی که در اپلیکیشن جهت افزایش سرعت و راحتی کار دارند؛ لازم به ذکر است که محافظت از اطلاعات کاربران وظیفه ماست؛`
                        },
                        {
                            id:60,
                            question:`۷۰۳۰ مناسب چه کسانی است؟`,
                            answer:`در وهله‌ی اول هفتاد سی مناسب تمام کسانی است که با شبکه­ های اجتماعی سروکار دارند و با کامپیوتر شخصی و یا گوشی هوشمند خود در پی دریافت خدمات اعتباری از قبیل خرید شارژ، پرداخت قبض و … می‌باشند. در وهله‌ی دوم و به طور خاص مناسب کسانی است که قابلیت و توان جذب افراد و نیز روابط عمومی بالایی در معرفی ۷۰۳۰ به دوستانشان و ترغیب آنها به استفاده از این سرویس دارند از جمله مدیران وبلاگ‌ها، کانال‌های تلگرامی و هر شخصی که شبکه مخاطبین گسترده‌ای دارد.`
                        },
                        
                    ]
                },
            ]
            var self=this
            this.searchResult=faq
            function searchQuestion(obj){
                
                for(let Question in obj.questionArray ){
                    if(obj.questionArray[Question].question.search(self.query)>-1 || obj.questionArray[Question].answer.search(self.query)>-1){
                        obj.show=true
                        return true
                    }
                }
            }
            function queryQuestion(question){
                    if(question.question.search(self.query)>-1 || question.answer.search(self.query)>-1){
                        question.question = highlight(question.question,self.query)
                        return true
                    }
            }
            function highlight(question,text) {

                var inputText = question;
                var index = inputText.indexOf(text);
                if (index >= 0) { 
                    inputText = inputText.substring(0,index) + "<span class='highlight'>" + inputText.substring(index,index+text.length) + "</span>" + inputText.substring(index + text.length);
                    return inputText
                }
                else{
                    inputText = inputText +'<span class="parantez"> (نتیجه جست و جو در پاسخ این سوال) </span>'
                    return inputText
                }
            }
            this.searchResult = this.searchResult.filter(searchQuestion)
            for(let obj in this.searchResult){
                this.searchResult[obj].questionArray = this.searchResult[obj].questionArray.filter(queryQuestion)
            }
        }
    },
    mounted(){
        if(this.$route.hash){
        setTimeout(() => {
           for(let obj in this.searchResult){
            for(let i in this.searchResult[obj].questionArray){
                if(this.$route.hash[2]){
                    if(this.searchResult[obj].questionArray[i].id==(this.$route.hash[1]+this.$route.hash[2])){
                        this.$store.state.question=this.searchResult[obj].questionArray[i]
                        this.openModal('faq')
                    }
                }
                else {
                    if(this.searchResult[obj].questionArray[i].id==(this.$route.hash[1])){
                        this.$store.state.question=this.searchResult[obj].questionArray[i]
                        this.openModal('faq')
                    }
                }
            }
        } 
        }, 0);
        }
        
        this.$store.state.loading=false
    }
}
</script>

<style>
.highlight {
  background-color: #55C38C;
  color: #fff
}
.parantez{
    color: #ccc
}

</style>
